document.addEventListener("contextmenu", function (e) {
  if (e.target.tagName === "IMG") {
    e.preventDefault();
  }
});

document.addEventListener("keydown", function (e) {
  // F12
  if (e.key === "F12") {
    e.preventDefault();
  }

  // Ctrl+Shift+I / J / C
  if (
    e.ctrlKey &&
    e.shiftKey &&
    ["I", "J", "C"].includes(e.key.toUpperCase())
  ) {
    e.preventDefault();
  }

  // Ctrl+U (View Source)
  if (e.ctrlKey && e.key.toLowerCase() === "u") {
    e.preventDefault();
  }
});

document.addEventListener("contextmenu", function (e) {
  e.preventDefault();
});

document.addEventListener("DOMContentLoaded", () => {
  const images = document.querySelectorAll("img");

  images.forEach((img) => {
    // Disable right-click
    img.addEventListener("contextmenu", (e) => e.preventDefault());

    // Disable long-press (mobile/tablet)
    let touchTimer;
    img.addEventListener("touchstart", () => {
      touchTimer = setTimeout(() => {
        // Optional: Add a visual cue or block interaction
      }, 500); // threshold for long press
    });
    img.addEventListener("touchend", () => clearTimeout(touchTimer));
    img.addEventListener("touchmove", () => clearTimeout(touchTimer));

    // Optional: Prevent text/image selection
    img.style.userSelect = "none";
    img.style.webkitUserSelect = "none";
    img.style.pointerEvents = "none"; // comment this if image needs to be clickable
  });

  let lastScrollTop = 0;

  window.addEventListener("scroll", function () {
    const currentScroll = window.scrollY;
    const widgets = document.querySelectorAll(
      ".gw-widget-placeholder-BL-wrapper, #chat-bubble"
    );

    widgets.forEach((widget) => {
      if (currentScroll > lastScrollTop) {
        // Scrolling down
        widget.classList.add("hide-on-scroll");
      } else {
        // Scrolling up
        widget.classList.remove("hide-on-scroll");
      }
    });

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  });
});

// Function to apply direction:ltr if .money is found
function applyLTRDirection() {
  document.querySelectorAll(".removable-facet").forEach((facet) => {
    const money = facet.querySelector(".money");
    const subdued = facet.querySelector(".text-subdued");

    if (money && subdued) {
      subdued.style.direction = "ltr";
      // Or use a class: subdued.classList.add('ltr-text');
    }
  });
}

// Run once immediately (for already-rendered elements)
applyLTRDirection();

// Set up MutationObserver
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) {
      applyLTRDirection();
    }
  });
});

// Observe the body or a more specific container (like the filter wrapper)
const container = document.querySelector("body"); // Replace with a more specific container if possible
if (container) {
  observer.observe(container, {
    childList: true,
    subtree: true,
  });
}

document.addEventListener("click", function (event) {
  const buyButton = event.target.closest(".custom-buy-button");
  if (buyButton) {
    const variantId = buyButton.getAttribute("data-variant-id");
    const quantityInput = document.querySelector(".quantity-selector__input");
    const quantity = parseInt(quantityInput?.value, 10) || 1;
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to add item to the cart");
        }
        return response.json();
      })
      .then(() => {
        window.location.href = "/checkout";
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
});

// Homepage redirection

document.addEventListener("DOMContentLoaded", function () {
  const lang = document.documentElement.lang;
  const browserLang = (navigator.language || navigator.userLanguage || '').toLowerCase();
  const currentPath = window.location.pathname;
  const search = window.location.search;
  const hash = window.location.hash;

  const skipRedirect = sessionStorage.getItem("skipArRedirect") === "true";

  // ✅ Redirect on load only if browser language is Arabic
  if (
    browserLang.startsWith("ar") &&
    lang === "en" &&
    !currentPath.startsWith("/ar") &&
    !skipRedirect
  ) {
    const newPath = "/ar" + currentPath;
    const newUrl = window.location.origin + newPath + search + hash;
    window.location.replace(newUrl);
    return;
  }

  // ✅ Click listener stays same
  document.body.addEventListener("click", function (e) {
    const button = e.target.closest("button.popover__value-option");
    if (!button) return;

    const selectedLang = button.value;

    if (selectedLang === "ar" && !currentPath.startsWith("/ar")) {
      sessionStorage.removeItem("skipArRedirect");
      const newPath = "/ar" + currentPath;
      const newUrl = window.location.origin + newPath + search + hash;
      window.location.replace(newUrl);
    }

    if (selectedLang === "en" && currentPath.startsWith("/ar")) {
      sessionStorage.setItem("skipArRedirect", "true");
      const newPath = currentPath.replace(/^\/ar/, "") || "/";
      const newUrl = window.location.origin + newPath + search + hash;
      window.location.replace(newUrl);
    }
  });
});

// Boxi app code modification

setTimeout(function () {
  // Get all container divs
  const builderSettingsList = document.querySelectorAll(
    '[data-testid="builder-visual-settings"]'
  );

  builderSettingsList.forEach((builderSettings) => {
    // Get all step-heading and step-description elements within this container
    const stepHeadings = builderSettings.querySelectorAll(
      '[data-testid="step-heading"]'
    );
    const stepDescriptions = builderSettings.querySelectorAll(
      '[data-testid="step-description"]'
    );

    // Move each heading outside the container
    stepHeadings.forEach((stepHeading) => {
      builderSettings.parentNode.insertBefore(stepHeading, builderSettings);
      stepHeading.style.display = "block"; // Show again
    });

    // Move each description outside the container
    stepDescriptions.forEach((stepDescription) => {
      builderSettings.parentNode.insertBefore(stepDescription, builderSettings);
      stepDescription.style.display = "block"; // Show again
    });
  });
}, 500); // 2000 milliseconds = 2 seconds



  document.addEventListener("DOMContentLoaded", function () {
    console.log(localStorage.getItem("accountcreated"));
  if (localStorage.getItem("accountcreated") === "true") {
    console.log('work');
    localStorage.removeItem("accountcreated");
    window.location.href = "/account";
    return;
  }
    const form = document.getElementById('create_customer');
    const passwordInput = document.querySelector('input[name="customer[password]"]');
    const confirmPasswordInput = document.querySelector('input[name="customer[confirm_password]"]');
    const submitButton = form?.querySelector('button[type="submit"]');

    if (!form || !passwordInput || !confirmPasswordInput || !submitButton) {
      console.error("Missing required elements.");
      return;
    }

    const lang = document.documentElement.lang?.toLowerCase() || 'en';
    const messages = {
      en: {
        short: 'Password must be at least 8 characters.',
        common: 'This password is too common or easily guessable.',
        mismatch: 'Passwords do not match.'
      },
      ar: {
        short: 'يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل.',
        common: 'كلمة المرور هذه شائعة جدًا أو من السهل تخمينها.',
        mismatch: 'كلمتا المرور غير متطابقتين.'
      }
    };

    const commonPasswords = ['password', '123456', 'qwerty', '111111', '123123'];
    const msg = messages[lang] || messages.en;

    let errorDiv = passwordInput.closest('.form-control')?.querySelector('.form-error-message');
    if (!errorDiv) {
      errorDiv = document.createElement('div');
      errorDiv.className = 'form-error-message text-sm text-red-error mt-1';
      errorDiv.style.display = 'none';
      passwordInput.parentNode.appendChild(errorDiv);
    }

    function validatePassword(showErrors = true) {
      const password = passwordInput.value.trim();
      const confirmPassword = confirmPasswordInput.value.trim();
      let message = '';

      if (password.length < 8) {
        message = msg.short;
      } else if (commonPasswords.includes(password.toLowerCase())) {
        message = msg.common;
      } else if (password !== confirmPassword) {
        message = msg.mismatch;
      }

      if (showErrors) {
        errorDiv.textContent = message;
        errorDiv.style.display = message ? 'block' : 'none';
      }

      return message === '';
    }

    passwordInput.addEventListener('input', () => validatePassword(true));
    confirmPasswordInput.addEventListener('input', () => validatePassword(true));

    // ✅ FORM SUBMIT HANDLER
    form.addEventListener('submit', function (e) {
      const isValid = validatePassword(true);
      if (!isValid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        console.warn("Form submission blocked due to validation.");
        return false;
      }

      // ✅ Mark time to detect post-registration redirect
      localStorage.setItem('accountcreated', 'true');
    });
  });
